__turbopack_context__.v({
  "buttonsContainer": "WHIbba_buttonsContainer",
  "cardPair": "WHIbba_cardPair",
  "cardsContainer": "WHIbba_cardsContainer",
  "container": "WHIbba_container",
  "flipBack": "WHIbba_flipBack",
  "flipFront": "WHIbba_flipFront",
  "flipInner": "WHIbba_flipInner",
  "flipped": "WHIbba_flipped",
  "hasMore": "WHIbba_hasMore",
  "header": "WHIbba_header",
  "headersAndButtonsContainer": "WHIbba_headersAndButtonsContainer",
  "headersContainer": "WHIbba_headersContainer",
  "inverse": "WHIbba_inverse",
  "subheader": "WHIbba_subheader",
  "textCard": "WHIbba_textCard",
  "textCardCopy": "WHIbba_textCardCopy",
  "textCardHeader": "WHIbba_textCardHeader",
});
